import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { reviewFacilitySelector } from 'store/selectors/reviews';
import { submitReview } from 'store/reviews/slice';

import { Card } from 'components/core/Card';
import { FacilityImageAndDetails } from 'components/facility/FacilityImageAndDetails';
import { HH } from 'components/core/Headline';
import { Page, Group } from 'components/core/Page';
import { ReviewForm } from 'components/review/ReviewForm';

import './ReviewPage.scss';

export const enhance = (Component) =>
	withPageViewTracking(PAGE_TYPES.REVIEW)(Component);


export function ReviewPage() {
	const dispatch = useDispatch();
	const actions = useMemo(
		() => bindActionCreators({ submitReview }, dispatch),
		[dispatch],
	);
	const { facility, email, confirmationCode, reviewStatus, requireConfirmationCode, source } =
		useSelector((state) => reviewFacilitySelector(state));

	return (
		<Page className="review-page">
			<div className="page-header">
				<div className="page-container">
						<HH>
							Rate and review
						</HH>
						<div>
							Leave a review to let others looking for storage know
							about the storage facility you rented a unit from.
						</div>
				</div>
			</div>
			<div className="page-container narrow">
				{!!facility.id && facility.isActive &&
						<Card>
							<FacilityImageAndDetails
								withReviews
								reviewData={facility.reviewMetadata}
								distance={facility.distance}
								facilityUrl={get(facility, 'url.facility')}
								image={facility.images && facility.images[0]}
								name={facility.name}
								location={facility.location}
							/>
						</Card>
				}
				<Group>
					<ReviewForm
						onSubmit={actions.submitReview}
						initialValues={{
							nickname: '',
							email: email || '',
							confirmationCode,
							source: source || ''
						}}
						facilityId={facility.id}
						reviewStatus={reviewStatus}
						requireConfirmationCode={requireConfirmationCode}
					/>
				</Group>
			</div>
		</Page>
	);
}

ReviewPage.propTypes = {
	actions: PropTypes.shape({
		submitReview: PropTypes.func
	}),
	facility: PropTypes.object,
	email: PropTypes.string,
	confirmationCode: PropTypes.string,
	reviewStatus: PropTypes.string,
	requireConfirmationCode: PropTypes.bool,
	source: PropTypes.string
};

export default enhance(ReviewPage);
